import React from 'react';

import { ITargetingPreset, TargetingPresetKey } from '~/src/dash/apiV2/targeting/targetingPresets';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { disableSelectTextStyle } from '~/src/dash/components/text/common';
import { borderRadius, fontSizing, spacing, Span, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { EAllowStatus, ELogicalOperator } from '~/src/dash/utils/options';
import { TargetingPresetParamKey } from '~/src/dash/views/tools/TargetingPresets/TargetingPresetFormView/config';
import { useTargetingSummaryTableStore } from '~/src/dash/views/tools/TargetingPresets/TargetingPresetFormView/TargetingSummaryTable/context';

export interface ISelectedOptionsWithLogicProps {
  preset: ITargetingPreset;
  valueKey: TargetingPresetKey;
  allowKey?: TargetingPresetKey;
  logicKey?: TargetingPresetKey;
  paramKey: TargetingPresetParamKey;
  convertValue: (value: string, options: ISelectOption[]) => string;
  listKey: string;
}

export const SelectedOptionsWithLogic = ({
  preset,
  valueKey,
  allowKey,
  logicKey,
  listKey,
  convertValue,
}: ISelectedOptionsWithLogicProps) => {
  const { lists } = useTargetingSummaryTableStore();
  // @ts-ignore
  const value = convertValue(preset[valueKey], lists[listKey]);
  const isOrLogic = logicKey ? preset[logicKey] !== ELogicalOperator.AND : null;

  return (
    <div>
      <Text small>
        {value && allowKey && (
          <span
            style={{
              verticalAlign: 'middle',
              lineHeight: fontSizing.small,
              paddingRight: spacing.extraSmall,
            }}
          >
            {preset[allowKey] !== EAllowStatus.DENY ? (
              <IconV2 name='available' color={publicaColors.green} />
            ) : (
              <IconV2 name='unavailable' color={publicaColors.red} />
            )}
          </span>
        )}
        {value && logicKey && (
          <Span
            bold
            style={{
              verticalAlign: 'middle',
              fontSize: fontSizing.extraSmall,
              paddingRight: spacing.extraSmall,
            }}
          >
            <div
              style={{
                display: 'inline',
                verticalAlign: 'middle',
                backgroundColor: isOrLogic ? publicaColors.ivory : publicaColors.lavender,
                border: `1px solid ${publicaColors.lightGray}`,
                borderRadius: borderRadius.small,
                padding: `2px ${spacing.small}`,
                ...disableSelectTextStyle,
              }}
            >
              {isOrLogic ? 'OR' : 'AND'}
            </div>
          </Span>
        )}
        {value}
      </Text>
    </div>
  );
};
